var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.25581V15.5C12 18.5376 9.53757 21 6.5 21C3.46243 21 1 18.5376 1 15.5V4.66667C1 2.64162 2.64162 1 4.66667 1C6.69171 1 8.33333 2.64162 8.33333 4.66667V15.4457C8.33333 16.4583 7.51252 17.2791 6.5 17.2791C5.48748 17.2791 4.66667 16.4583 4.66667 15.4457V5.65116",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendAttachment);
export default __webpack_public_path__ + "static/media/send_attachment.fae7e02179549c5939fbf05431729d2d.svg";
export { ForwardRef as ReactComponent };